import {
  getBiosOutput,
  getCitation,
  getFormatted,
  mergeItems
} from "../../lib/formatUtilities.js";
import { getField } from "../../lib/utilities.js";

export default {
  Title: "Mayo Clinic Output DO NOT MAP",
  template: "/templateFiles/mayo_template_v1_0.docx",
  outputSettings: { font: "Arial", fontSize: 10 },
  output: {
    bio: {
      field: "bio",
      map: {
        bios: getBiosOutput(
          [
            { key: "name", title: "Name" },
            { key: "officeAddress", title: "Office Address" },
            { key: "workPhone", title: "Work Phone" },
            { key: "workEmail", title: "E-Mail" },
            { key: "dept", title: "Department" },
            { key: "institution", title: "Institution" }
          ],
          { font: "Arial", fontSize: 10 }
        ),
        bio_name: "name"
      }
    },
    // Present Academic Rank and Position
    par: {
      field: "facultyAppointments",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([{ key: "title" }, { key: "field" }, { key: "location" }])
        ]
      }
    },
    // Education
    edu: {
      field: "education",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "location" },
            { key: "degree" },
            { key: "secondaryInfo" }
          ])
        ]
      }
    },
    // Certification
    cert: {
      field: "clinicalActivityAndInnovations",
      section: "certification",
      type: "certification",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [mergeItems([{ key: "title" }, { key: "description" }])]
      }
    },
    // Licensure
    lic: {
      field: "clinicalActivityAndInnovations",
      section: "licensure",
      type: "Current Licensure and Certification",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: ["location"],
        2: [mergeItems([{ key: "title" }, { key: "number" }])]
      }
    },
    // Honors and Awards
    hon: {
      field: "honors",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: ["title", "location"]
      }
    },
    // Previous Professional Positions
    prev: {
      field: "otherPositions",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [mergeItems([{ key: "title" }, { key: "location" }])]
      }
    },
    // Service
    servSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "military")
            .filter(filter)
            .concat(getField(cvDef, "community").filter(filter)).length > 0
        );
      }
    },
    // Military Service
    mil: {
      field: "military",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: ["title"]
      }
    },
    // Community Service
    cs: {
      field: "community",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [mergeItems([{ key: "organization" }, { key: "role" }])]
      }
    },
    // Professional Memberships and Societies
    soc: {
      field: "societies",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: ["society"]
      },
      sublist: {
        roles: {
          t: ["limitedMonthAndFullYear"],
          1: [getFormatted("roles", { indent: 600 })]
        }
      }
    },
    // Educational Interests and Accomplishments
    ei: {
      field: "teaching",
      preface: true,
      group: {
        eiCurriculum: {
          type: "educationalDev",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [
              "title",
              mergeItems([
                { key: "role" },
                { key: "description" },
                { key: "institution" },
                { key: "location" }
              ])
            ]
          }
        },
        eiTeach: {
          type: "Teaching of Students in Courses",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [
              "title",
              "workTime",
              "role",
              "position",
              mergeItems([{ key: "institution" }, { key: "location" }]),
              "description"
            ]
          }
        },
        eiExcel: {
          type: "Formal Teaching of Peers (e.g., CME and other continuing education courses)",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [
              "title",
              mergeItems([
                { key: "role" },
                { key: "description" },
                { key: "institution" },
                { key: "location" }
              ])
            ]
          }
        },
        eiMent: {
          type: "Formally Mentored Trainees",
          format: {
            1: [mergeItems([{ key: "title" }, { key: "role" }])],
            2: ["limitedMonthAndFullYear", "description"],
            3: ["projectTitle"],
            4: ["position"]
          }
        },
        eiCareer: {
          type: "research",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [
              "title",
              mergeItems([
                { key: "role" },
                { key: "institution" },
                { key: "location" }
              ]),
              "description"
            ]
          }
        },
        eiAct: {
          type: "external",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [
              "title",
              mergeItems([
                { key: "role" },
                { key: "description" },
                { key: "institution" },
                { key: "location" }
              ])
            ]
          }
        }
      }
    },
    // Institutional/Departmental Admistrative Responsibilities, Committee Memberships, and Other Activities
    com: {
      field: "committeeService",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: ["institution"]
      },
      sublist: {
        roles: {
          t: ["limitedMonthAndFullYear"],
          1: [getFormatted("roles", { indent: 600 })]
        }
      }
    },
    // Presentatons Extramural
    pres: {
      field: "presentations",
      type: "national",
      preface: true,

      group: {
        intNat: {
          filter: (n) => !n.invitedProfessorship,
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [
              "title",
              "event",
              mergeItems([{ key: "organization" }, { key: "citystate" }])
            ]
          }
        },
        visitingProf: {
          filter: (n) => n.invitedProfessorship,
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [
              "title",
              "event",
              mergeItems([{ key: "organization" }, { key: "citystate" }])
            ]
          }
        }
      }
    },
    // Clinical Practice, Interests
    clinPrac: {
      field: "clinicalActivityAndInnovations",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "description" },
            { key: "role" }
          ])
        ]
      },
      sections: [
        { title: "General Emergency Medicine", type: "Practice Activities" },
        { title: "Academic Nursing Education", type: "leadership" },
        {
          title: "Technology Applications for Nursing Education",
          type: "Clinical Innovations"
        }
      ]
    },
    // Quality Initiatives
    qi: {
      field: "researchInterests",
      xml: true,
      map: {
        qi_qualityInitiatives: "quality"
      }
    },
    // Research Interests
    ri: {
      field: "researchInterests",
      xml: true,
      map: {
        ri_researchInterests: "current"
      }
    },
    // Research Grants
    gra: {
      field: "projects",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: ["role", "piName"],
        2: [mergeItems([{ key: "title" }, { key: "fundingSource" }])]
      },
      sections: [
        {
          title: "Active Grants",
          filter: (n) => n.grantType == "Active Grant"
        },
        { title: "Federal", filter: (n) => n.grantType == "Federal" },
        { title: "Mayo Clinic", filter: (n) => n.grantType == "Mayo Clinic" },
        {
          title: "Completed Grants",
          filter: (n) => n.grantType == "Completed Grant"
        }
      ]
    },
    // Inventions
    inv: {
      field: "technologyAndScienceInnovations",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: ["title"],
        2: ["description"],
        3: ["location"],
        4: ["source"]
      },
      group: {
        invPat: {
          type: "invention"
        },
        invOth: {
          type: "other"
        }
      }
    },
    // Bibliography
    bib: {
      field: "scholarship",
      preface: true,
      format: {
        1: function (item, i, cvDef, genOpts) {
          return i + 1;
        },
        2: function (item, i, cvDef, genOpts) {
          return [
            getCitation("line")(item, i, cvDef, genOpts),
            getFormatted("comments", { indent: 600 })(item, i, cvDef, genOpts)
          ].join(genOpts.noXML ? "<br>" : "");
        }
      },
      sections: [
        {
          title: "Published Peer-Reviewed Articles",
          type: "Research Investigations"
        },
        {
          title: "Non Peer-Reviewed Published Articles",
          type: "researchNotReviewed"
        },
        { title: "Conference Reports", type: "Case reports" },
        { title: "Books", type: "books" },
        { title: "Book Chapters", type: "chapters" },
        {
          title: "Edited Books",
          type: "Reviews, chapters, monographs and editorials"
        },
        { title: "Editorials", type: "editorials" },
        { title: "Commentaries", type: "commentaries" },
        { title: "Audio/Video/CD ROM/etc.", type: "tech" },
        {
          title: "Abstracts",
          type: "Abstracts, Poster Presentations and Exhibits Presented at Professional Meetings"
        },
        { title: "Letters", type: "Letters to the Editor" },
        { title: "Stamp Vignettes", type: "posters" },
        { title: "Thesis", type: "Thesis" },
        {
          title: "Ask Mayo Expert Model",
          type: "Professional educational materials or reports, in print or other media"
        },
        { title: "Ask Mayo Expert Topic", type: "creativeWriting" },
        { title: "Book Reviews", type: "reviews" },
        { title: "Scientific Reports", type: "proceedingsReports" },
        { title: "Miscellaneous", type: "otherPeer" },
        { title: "Social Media Activity", type: "media" },
        { title: "Forthcoming", type: "otherAbstracts" }
      ]
    }
  }
};
